/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageLevelEnum } from './messageLevelEnum';
import { MessageTypeEnum } from './messageTypeEnum';
import { Message } from './message';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { MessageReplyTo } from './messageReplyTo';
import { MessageRecipient } from './messageRecipient';


export interface NotificationMessageRequest { 
    service_type: ServiceTypeEnum;
    type: MessageTypeEnum;
    level?: MessageLevelEnum;
    /**
     * Email id for \'from\'. Default value \'donotreply@vmware.com\'.
     */
    from?: string;
    recipient?: MessageRecipient;
    reply_to?: MessageReplyTo;
    message: Message;
    /**
     * Time after which the notification should expire. This could be time in seconds, minutes, hours and days.
     */
    expires_in?: string;
    /**
     * CC email id list
     */
    cc?: Array<string>;
    /**
     * BCC email id list
     */
    bcc?: Array<string>;
}
export namespace NotificationMessageRequest {
}


